var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49996 5.25016H2.62496C2.23819 5.25016 1.86725 5.09652 1.59376 4.82303C1.32027 4.54954 1.16663 4.1786 1.16663 3.79183C1.16663 3.40506 1.32027 3.03412 1.59376 2.76063C1.86725 2.48714 2.23819 2.3335 2.62496 2.3335H3.49996",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.25016H11.375C11.7618 5.25016 12.1327 5.09652 12.4062 4.82303C12.6797 4.54954 12.8333 4.1786 12.8333 3.79183C12.8333 3.40506 12.6797 3.03412 12.4062 2.76063C12.1327 2.48714 11.7618 2.3335 11.375 2.3335H10.5",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 12.8335H11.6667",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 8.55176V9.91676C5.83337 10.2376 5.55921 10.4884 5.26754 10.6226C4.57921 10.9376 4.08337 11.8068 4.08337 12.8334",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 8.55176V9.91676C8.16663 10.2376 8.44079 10.4884 8.73246 10.6226C9.42079 10.9376 9.91663 11.8068 9.91663 12.8334",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.1665H3.5V5.24984C3.5 6.17809 3.86875 7.06833 4.52513 7.72471C5.1815 8.38109 6.07174 8.74984 7 8.74984C7.92826 8.74984 8.8185 8.38109 9.47487 7.72471C10.1313 7.06833 10.5 6.17809 10.5 5.24984V1.1665Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademics);
export default __webpack_public_path__ + "static/media/Academics.56b15c0f6717b446e0872133ce52004d.svg";
export { ForwardRef as ReactComponent };